import React, { useEffect, useState } from 'react';
import { GetServerSideProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import { toast } from 'react-toastify';

import { AuthLayout } from '../components/auth';
import { Button, Separator } from '../components/common';
import NextLink from '../components/common/next-link/NextLink';
import EmailForm from '../components/auth/email-form/EmailForm';
import VerificationCodeForm from '../components/auth/verification-code-form/VerificationCodeForm';
import { composeSocialAuthHref, withAuth } from '../helpers/auth';
import { ERROR_MESSAGE_GENERIC } from '../constants/common';
import { getAccessTokenCookie } from '../helpers/cookies';

const SignInPage: NextPage = () => {
  const [email, setEmail] = useState<string>('');

  const router = useRouter();

  const nextUrl =
    typeof router?.query.nextUrl === 'string' ? router.query.nextUrl : null;

  useEffect(() => {
    if (router?.query.expiredSession === 'true') {
      toast.info('Your session has expired. Please sign in again.', {
        position: 'top-right',
      });
    }

    if (router?.query.error === 'true') {
      toast.error(ERROR_MESSAGE_GENERIC, {
        position: 'top-right',
      });
    }
  }, [router?.query?.expiredSession, router?.query?.error]);

  return (
    <AuthLayout>
      <div className="mb-10 text-center">
        <h1 className="mb-4">Sign in to Ktown</h1>
        <div>
          Don&apos;t have an account yet?{' '}
          <NextLink href="/sign-up">Sign up now</NextLink>
        </div>
      </div>

      {!!email ? (
        <VerificationCodeForm email={email} nextUrl={nextUrl} />
      ) : (
        <EmailForm onSuccess={setEmail} />
      )}

      <Separator content="Or" />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Button
          as="a"
          kind="primary"
          size="big"
          filled={false}
          href={composeSocialAuthHref('google-oauth2', nextUrl)}
          className="w-full bg-red-400"
        >
          with Google
        </Button>

        <Button
          as="a"
          kind="primary"
          size="big"
          filled={false}
          href={composeSocialAuthHref('facebook', nextUrl)}
          className="w-full bg-red-400"
        >
          with Facebook
        </Button>
      </div>
    </AuthLayout>
  );
};

export const getServerSideProps: GetServerSideProps = withAuth(
  false,
  async (context) => {
    if (!!getAccessTokenCookie(context)) {
      return {
        redirect: {
          destination: '/',
          permanent: false,
        },
      };
    }

    return {
      props: {},
    };
  }
);

export default SignInPage;
